module.exports = __webpack_public_path__ + "static/img/2.4.7a9b9af.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/upload/picture/2.4.jpg
// module id = UwJ6
// module chunks = 7